<template>
  <div class="main_home">
    <div class="home_header">
      <div class="mb10 fs17">下午好，{{ userInfo.realname }}</div>
      <div class="fs13">
        今天是 {{ nowDate }} {{ nowWeek }}，欢迎访问豆米跳跳官网后台管理平台
      </div>
      <div style="font-size: 20px;font-weight: bold;margin-top: 30px;color: #144077">
        【网站静态化】
      </div>
      <div class="content">
        <el-button class="btn" :loading="loading[0]"  type="primary" @click="staticPage(0)">首页</el-button>
        <el-button class="btn" :loading="loading[6]"  type="primary"  @click="staticPage(6)">Alot物联</el-button>
        <el-button class="btn" :loading="loading[5]"  type="primary" @click="staticPage(5)">最新动态</el-button>
        <el-button class="btn" :loading="loading[3]"  type="primary" @click="staticPage(3)">关于我们</el-button>
        <el-button class="btn" :loading="loading[4]"  type="primary" @click="staticPage(4)">渠道合作</el-button>
      </div>
      <div class="content">
        <el-button class="btn" :loading="loading[7]"   type="primary" @click="staticPage(7)">最新动态详情</el-button>
        <el-button class="btn" :loading="loading[9]"  type="primary" @click="staticPage(9)">客户案例详情</el-button>
        <el-button class="btn" :loading="loading[9]"  type="primary" @click="staticPage(14)">轮播图详情</el-button>
      </div>
      <div style="font-size: 20px;font-weight: bold;margin-top: 30px;color: #144077">
        【智慧系统静态化】
      </div>
      <div class="content">
        <el-button class="btn" :loading="loading[1]"  type="primary" @click="staticPage(1)">智慧系统运营系统</el-button>
        <el-button class="btn" :loading="loading[2]"  type="primary" @click="staticPage(2)">智慧系统运维系统</el-button>
      </div>
      <div style="font-size: 20px;font-weight: bold;margin-top: 30px;color: #144077">
        【解决方案静态化】
      </div>
      <div class="content">
        <el-button class="btn" :loading="loading[8]"  type="primary" @click="staticPage(8)">数智体育场馆</el-button>
        <el-button class="btn" :loading="loading[10]"  type="primary" @click="staticPage(10)">24H智能场馆</el-button>
        <el-button class="btn" :loading="loading[11]"  type="primary" @click="staticPage(11)">景区&游乐园</el-button>
        <el-button class="btn" :loading="loading[12]"  type="primary" @click="staticPage(12)">数智体育平台</el-button>
        <el-button class="btn" :loading="loading[13]"  type="primary" @click="staticPage(13)">空间智慧管理</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { weeks } from '@/utils/config'
import { create as createPage } from '@/api/business/static'
export default {
  components: {
  },
  data () {
    return {
      loading:[false,false,false,false,false,false,false,false,false,false]
    }
  },
  computed: {
    userInfo () {
      return this.$store.state.userInfo
    }
  },
  created () {
  },
  mounted () {
    this.updateDate()
    // this.initData()
  },
  methods: {
    staticPage (index) {
      this.loading[index] = true
      createPage({ pageIndex: index }).then(res => {
        this.$message.success('操作成功')
      }).catch(e => {
        this.$tip.apiFailed(e)
      }).finally(() => {
        this.loading[index] = false
      })
    },
    updateDate () {
      this.nowDate = dayjs().format('YYYY年M月D日')
      this.nowWeek = weeks[new Date().getDay()]
    }
  }
}
</script>

<style lang="scss" scoped>

div {
  box-sizing: border-box;
}

.home_title {
  font-weight: 600;
  font-size: 16px;
  color: #222222;
  line-height: 22px;
}
.content {
  display: flex;
  margin-top: 30px;
  width: 100%;
  .btn{
    width: 18%;
    height: 60px;
    margin: 10px;
    font-size: 20px;
  }
}

.main_home {
  background: #f4f7fc;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 92px 20px 20px;
  .home_header {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 200px;
    padding: 20px;
    color: #fff;
    background: linear-gradient(180deg, #076ae5 0%, rgba(32, 127, 247, 0) 100%);
  }
}
</style>
